import React, { useEffect } from "react";
import { Card, Container, Row, Col, Button } from "reactstrap";
import { default_currency } from "../../../Site";
import { T } from "../../../traks";
import store from "../../../store";

export const PremiumPackageCard = ({
  title,
  description,
  discountedPrice,
  price,
  binding,
  details,
  className,
  setSelectedPackage,
  selectedPackage,
  id,
  showSelectedState = true,
}) => {

  const handleClick = () => {
      if (showSelectedState) {
        setSelectedPackage(isSelected ? null : id);
      } else {
        store.dispatch_value('show_cart', true);
        store.dispatch_value('selected_package', id);
      }
    };

    const isSelected = selectedPackage === id;
    return (
            <Card className={`pt-3 pb-3 d-flex flex-column h-100 border-radius-10 ${className || ""}` }>
                <Container className="d-flex flex-column h-100">
                    <div className="flex-grow-1">
                        <Row>
                            <Col sm>
                                <span className="ad_110pct"><b className="font-weight-700">{title}</b></span>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                {description ? (
                                    <span className="ad_90pct">{description}</span>
                                ) : (
                                    <span className="ad_90pct item-hidden">placeholder</span>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span className="premium-green ad_125pct"><b>{discountedPrice} {default_currency}</b></span>&nbsp;
                                <span className="txt-line-through"><b className="font-weight-700">{price} {default_currency}</b></span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>{binding}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <hr className="section-divider"/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ul className="package-features">
                                    {details.map((item, idx) => (
                                        <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col>
                            <Button
                                className={`w-100 ad_new_game_button px-4 py-2 btn btn-secondary ${
                                    isSelected && showSelectedState ? 'btn-success' : ''
                                }`}
                                onClick={() => handleClick()}
                            >
                                {isSelected && showSelectedState ? <T>Selected</T> : <T>Select package</T>}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Card>
        );
}



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Package/PremiumPackageCard.js